import { Component, computed, input } from '@angular/core';

@Component({
    selector: 'fb-stat-card',
    template: `
        <div class="flex flex-col gap-3 p-5 rounded-md bg-surface border border-border h-full">
            <div class="flex items-center justify-between gap-2">
                <p class="text-xs font-semibold text-text-muted uppercase tracking-widest">{{ label() }}</p>
                @if (icon()) {
                    <span class="size-8 flex items-center justify-center rounded-sm bg-concern-accent text-concern-accent-dot">
                        <i [class]="'ph ' + icon()"></i>
                    </span>
                }
            </div>
            <p class="text-3xl font-bold text-text font-display">{{ value() }}</p>
            @if (delta() !== null && delta() !== undefined) {
                <span
                    class="inline-flex items-center gap-1 text-xs font-semibold w-fit px-1.5 py-0.5 rounded"
                    [class]="positive() ? 'bg-concern-success text-concern-success-title' : 'bg-concern-warn text-concern-warn-title'">
                    <i [class]="positive() ? 'ph ph-arrow-up' : 'ph ph-arrow-down'"></i>
                    {{ absDelta() }}%
                </span>
            }
            @if (hint()) {
                <p class="text-xs text-text-muted">{{ hint() }}</p>
            }
        </div>
    `
})
export class StatCardComponent {
    label = input.required<string>();
    value = input.required<string | number>();
    icon = input<string>();
    delta = input<number | null>(null);
    hint = input<string>();

    positive = computed(() => (this.delta() ?? 0) >= 0);
    absDelta = computed(() => Math.abs(Math.round(this.delta() ?? 0)));
}
